window.addEventListener('load',()=>{
	/* Inputs password */
	/* -------------------------------------------------------------------------------------- */
	$('[js-button-view]').on('click', function(event) {
		event.preventDefault();
		/* Act on the event */
		var input = $(this).siblings('#CustomerPassword');
		var type = input.attr('type');
		if (type === "password") {
			input.attr('type', 'text');
		  } else {
		  	input.attr('type', 'password');
		  }
	});
});